import React from 'react';
import { StarIcon } from 'lucide-react';
import { featuredTestimonials, testimonials } from '../data/content';
const allTestimonials = [...testimonials];
function initials(name: string): string {
  return name.split(' ').map(part => part[0]).join('').slice(0, 2).toUpperCase();
}
export function Testimonials() {
  return <section className="bg-night" data-id="element-252" data-mp="3azj9dk7whw5v">
      <div className="mx-auto max-w-content px-6 py-16 lg:py-24" data-id="element-253" data-mp="3ayhzhj2mffpq">
        <h2 className="text-center font-display text-3xl font-semibold tracking-tight text-parchment sm:text-4xl" data-id="element-254" data-mp="36zqyh0v1bdxc">
          Lo que dicen quienes ya lo usan
        </h2>

        <div className="mt-10 grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-255" data-mp="2x09wouiwlk6n">
          {allTestimonials.map(item => <figure key={item.name} className="flex h-full flex-col rounded-2xl border border-night-line bg-night-panel p-6" data-id="element-256" data-mp="2s2i561m6802z">
              <div className="flex items-center gap-3" data-id="element-257" data-mp="v8555k5bgowg">
                <span aria-hidden="true" className="flex h-10 w-10 flex-none items-center justify-center rounded-full bg-gold/20 font-sans text-sm font-semibold text-gold-soft" data-id="element-258" data-mp="qall23lxthwl">
                  {initials(item.name)}
                </span>
                <div className="flex gap-0.5" aria-label="5 de 5 estrellas" data-id="element-259" data-mp="m5t14mo4maqs">
                  {Array.from({
                length: 5
              }).map((_, index) => <StarIcon key={index} className="h-4 w-4 fill-gold-soft text-gold-soft" aria-hidden="true" data-id="element-260" data-mp="c6lknqm3hzzg" data-mpi={index} />)}
                </div>
              </div>

              <blockquote className="mt-4 font-sans text-base leading-relaxed text-parchment/85" data-id="element-261" data-mp="zwy1xs38d92p">
                “{item.quote}”
              </blockquote>
              <figcaption className="mt-auto pt-5 font-sans text-sm text-parchment/55" data-id="element-262" data-mp="q766kvnb4bx6">
                — <span className="font-semibold text-parchment/80" data-id="element-263" data-mp="v5g1r6917cis">{item.name}</span>,{' '}
                {item.role}
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}